import { Component, OnInit, inject } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ApiServiceService, NotificationService } from '@oneeducation/app-core';
import { USER_ENDPOINT } from '@shared/properties';
import { userModel } from '@usermanagement/models/userModel';
import { UserRoleService } from '@usermanagement/services';

@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.scss'],
  standalone: false
})
export class UserRegistrationComponent implements OnInit {
  private readonly userService = inject(UserRoleService);
  private readonly apiService = inject(ApiServiceService);
  private readonly notificationService = inject(NotificationService);

  public User: userModel;
  isDataLoadedForUser: boolean;
  display: boolean;

  userFields = new FormGroup({
    FirstName: new FormControl<string | null>(null, Validators.required),
    FamilyName: new FormControl<string | null>(null, Validators.required)
  });

  ngOnInit(): void {
    if (this.validateUserDetails()) {
      this.showRegistrationDialog();
    } else {
      this.userService.userInfoReceived.subscribe((x) => {
        if (this.validateUserDetails()) {
          if (x) {
            this.showRegistrationDialog();
          }
        }
      });
    }
  }

  // Check and return true if valid User object and
  // firstName and LastName is empty/null
  validateUserDetails(): boolean {
    if (
      this.userService.User &&
      !this.userService.User.firstName &&
      !this.userService.User.familyName
    ) {
      return true;
    }
    return false;
  }

  showRegistrationDialog() {
    this.isDataLoadedForUser = this.userService.User.email !== '';
    this.display = true;
    this.User = this.userService.User;
  }

  get f() {
    return this.userFields.controls;
  }

  saveUser() {
    if (this.userFields.valid) {
      this.User.familyName = this.userFields.value.FamilyName;
      this.User.firstName = this.userFields.value.FirstName;
      this.apiService.put(USER_ENDPOINT.UpdateUser, this.User).subscribe({
        next: () => {
          this.display = false;
          this.userService.User.firstName = this.User.firstName;
          this.userService.User.familyName = this.User.familyName;
        },
        error: () => {
          this.notificationService.showError(
            'Something went wrong, please try again.'
          );
        }
      });
    }
  }
}
